import { FormEvent, useState } from 'react';

import { Copy16 } from '@ingrid/iconography/react';
import { IconButton, Tooltip } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

interface Props {
  value: string;
}

export function CopyButton(props: Props) {
  const { value } = props;
  const { t } = useTranslation();
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyAndShowTooltip = async (e: FormEvent) => {
    e.preventDefault();

    await navigator.clipboard.writeText(value);

    setIsCopied(true);
    setTimeout(() => setIsCopied(false), TOOLTIP_IS_COPIED_DURATION);
  };

  const tooltipAriaLabel = t(isCopied ? 'common.copied' : 'common.copyAriaLabel');
  const tooltipLabel = t(isCopied ? 'common.copied' : 'common.copyAriaLabel');

  return (
    <Tooltip content={tooltipLabel}>
      <IconButton aria-label={tooltipAriaLabel} onClick={handleCopyAndShowTooltip} size="sm" variant="tertiary">
        <Copy16 />
      </IconButton>
    </Tooltip>
  );
}

const TOOLTIP_IS_COPIED_DURATION = 3000;
